import { Component, OnInit, Input } from '@angular/core';
import { TradingService } from '../../../../services/common/trading-service.service';
@Component({
  selector: 'cancel-annuity-order-details',
  templateUrl: './cancel-annuity-order-details.component.html',
  styleUrls: ['./cancel-annuity-order-details.component.css']
})
export class CancelAnnuityOrderDetailsComponent implements OnInit {
  @Input() order: any;
  @Input() ordQty: any;
  activeTheme: string;
  constructor(private tradingService: TradingService) { }

  ngOnInit() {
    this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer(); 
  }
}
